// src/pages/BillingReports.js
import React from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";   // ✅ using global layout

import { auth } from "../firebase";

function BillingReports() {
  const navigate = useNavigate();

  return (
    <Layout>
      <div
        style={{
          padding: 20,
          marginLeft: "0px",
          width: "100%",
          overflowX: "auto",
        }}
      >
        <div style={{ padding: 20 }}>
          <h2>Billing Reports</h2>
          <p>Select a report type:</p>

          <div
            style={{
              display: "flex",
              gap: 20,
              marginTop: 20,
              flexWrap: "wrap",
            }}
          >
            {/* Order Summary */}
            <div
              onClick={() => navigate("/reports/order-head")}
              style={{
                cursor: "pointer",
                padding: 20,
                borderRadius: 12,
                border: "5px solid #ccc",
                minWidth: 220,
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              }}
            >
              <h3>Order Summary</h3>
              <p style={{ fontSize: 13 }}>
                One row per order – totals by order.
              </p>
            </div>

            {/* Order Lines */}
            <div
              onClick={() => navigate("/reports/order-lines")}
              style={{
                cursor: "pointer",
                padding: 20,
                borderRadius: 12,
                border: "5px solid #ccc",
                minWidth: 220,
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              }}
            >
              <h3>Sales Lines Report</h3>
              <p style={{ fontSize: 13 }}>
                One row per SKU per order – full detail.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default BillingReports;
